import { MonetizationType } from '@/@types/graphql-types';
import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { WatchNowOfferFragment } from '@/pages/graphql/fragments/WatchNowOffer.fragment';

const jwTVModal = () => import('@/features/jwtv-avod/components/JWTVAvodModal.vue');

type JwTVModalProps = {
	offer: WatchNowOfferFragment | TitleOfferFragment;
	title?: TitleDetail;
	additionalContexts?: SnowplowContext[];
};

export async function openJwTvAvodModal(payload: { modalProps: JwTVModalProps; onClose?: () => void }) {
	await ModalHelper.openModal(
		jwTVModal,
		{
			...payload.modalProps,
		},
		{ cssClass: 'trailer-modal' },
		'',
		true,
		payload.modalProps.additionalContexts ?? [],
		() => {
			payload.onClose?.();
		}
	);
}

export function isJWTVAvodOffer(offer: TitleOfferFragment | WatchNowOfferFragment): boolean {
	const isJustWatchTvPackage = offer?.package.shortName === 'jwt';
	const isFreeOrAds = [MonetizationType.Free, MonetizationType.Ads].includes(offer.monetizationType);

	return isJustWatchTvPackage && isFreeOrAds;
}
